export default "__VITE_ASSET__n7G2Dx9o__"